import type { Object3D } from "three";

const runtimeObjects = new Map<string, Object3D>();

export const objectRegistry = {
  set: (id: string, object: Object3D) => runtimeObjects.set(id, object),
  get: (id: string) => runtimeObjects.get(id),
  delete: (id: string) => runtimeObjects.delete(id),
  clear: () => runtimeObjects.clear(),
};
